import React from "react";

import Charlie191 from './images/Charlie19/19Charlie_001 Large.jpeg';
import Charlie192 from './images/Charlie19/19Charlie_002 Large.jpeg';
import Charlie193 from './images/Charlie19/19Charlie_003 Large.jpeg';
import Charlie194 from './images/Charlie19/19Charlie_004 Large.jpeg';
import Charlie195 from './images/Charlie19/19Charlie_005 Large.jpeg';
import image6 from './images/Charlie19/19Charlie_006 Large.jpeg';
import image7 from './images/Charlie19/19Charlie_007 Large.jpeg';
import image8 from './images/Charlie19/19Charlie_008 Large.jpeg';
import image9 from './images/Charlie19/19Charlie_009 Large.jpeg';
import image10 from './images/Charlie19/19Charlie_010 Large.jpeg';
import image11 from './images/Charlie19/19Charlie_011 Large.jpeg';
import image12 from './images/Charlie19/19Charlie_012 Large.jpeg';
import image13 from './images/Charlie19/19Charlie_013 Large.jpeg';
import image14 from './images/Charlie19/19Charlie_014 Large.jpeg';
import image15 from './images/Charlie19/19Charlie_015 Large.jpeg';
import image16 from './images/Charlie19/19Charlie_016 Large.jpeg';
import image17 from './images/Charlie19/19Charlie_017 Large.jpeg';
import image18 from './images/Charlie19/19Charlie_018 Large.jpeg';
import image19 from './images/Charlie19/19Charlie_019 Large.jpeg';

const Charlie19 = () => {
    return (
    <div className="picture-gallery">
        <div className="photo-column">
            <div className="single portrait fs-height">
                <img src={Charlie191}/>
            </div>
            <div className="single portrait fs-height">
                <img src={Charlie192}/>
            </div>
            <div className="single portrait fs-height">
                <img src={Charlie193}/>
            </div>
            <div className="single portrait fs-height">
                <img src={Charlie194}/>
            </div>
            <div className="single portrait fs-height">
                <img src={Charlie195}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image6}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image7}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image8}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image9}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image10}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image11}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image12}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image13}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image14}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image15}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image16}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image17}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image18}/>
            </div>
            <div className="single portrait fs-height">
                <img src={image19}/>
            </div>
            
            <div className="single portrait fs-height-2">
                <div className="text">
                “I came to a point in my life where I felt out of place and even though my life was heading in a certain direction, to me it felt like I had no direction at all. I always knew that Chrysalis Academy was all about personal development, but I first had to find out whether or not I stood a chance of getting in. To my luck and advantage I was accepted and today while I'm writing this, I'm sitting in my dorm room, a few weeks away from graduation and in a better space than when I started this 3 months journey. I’m Ian Van Der Schuff and I am at Chrysalis Academy and a 19 Charlie graduate! " 
                </div>
            </div>
        </div>
    </div>
    );
}

export default Charlie19;